import { instance, instanceRoot } from "./apiRequest";

import {
    Submit_Applicant_Details_Api, Submit_Upload_Documents_Api, SEND_VERIFY_EMAIL_OTP, CONFIRM_EMAIL_OTP, UPDATE_APPLICANT_DATA, GET_ALL_DROPDOWN_DATA_BY_NAME, GET_APPLICANT_INFORMATION_BY_APPLICATION_ID, ADD_OR_UPDATE_CASH_SHORT_TERM_INVESTMENTS, GET_CASH_SHORT_TERM_INVESTMENTS_BY_APPLICATIONID, DELETE_CASH_SHORT_TERM_INVESTMENTS_BY_CASH_ID,
    GET_APPLICATION_LIST_BY_EMAIL,
    ADD_OR_UPDATE_STOCK_BOND_GOV_SECURITY,
    GET_STOCK_BOND_GOV_SECURITY_BY_APPLICATION_ID,
    DELETE_STOCK_BOND_GOV_SECURITY_BY_STOCK_ID,
    GET_ACCOUNT_NOTE_RECEIVABLE_BY_APPLICATION_ID,
    ADD_O_RUPDATE_ACCOUNT_NOTE_RECEIVABLE,
    DELETE_ACCOUNT_NOTE_RECEIVABLE_BY_ACCOUNT_ID,
    ADD_OR_UPDATE_CASH_VALUE_LIFE_INSURANCE,
    DELETE_CASH_VALUE_LIFE_INSURANCE_BY_CASHVALUE_ID,
    GET_CASH_VALUE_LIFE_INSURANCE_BY_APPLICATION_ID,
    UPDATE_APPLICANT_FINANCIAL_DATA,
    GET_FINANCIAL_STATEMENT_DATA, UPLOAD_PHOTO_IMAGE, UPLOAD_PDF_OR_DOC_FILE,
    ADD_OR_UPDATE_INCOME_SOURCE, GET_INCOME_SOURCE_BY_APPLICATION_ID, ADD_OR_UPDATE_EXPENSES, GET_EXPENSES_BY_APPLICATION_ID,
    ADD_OR_UPDATE_OWN_PERSONAL_RESIDENCE,
    GET_OWN_PERSONAL_RESIDENCE_BY_APPLICATION_ID,
    DELETE_OWN_PERSONAL_RESIDENCE_BY_OWN_ID,
    ADD_OR_UPDATE_VESTED_INTREST_PENSION,
    GET_VESTED_INTREST_PENSION_BY_APPLICATION_ID,
    DELETE_VESTED_INTREST_PENSION_BY_OWN_ID,
    ADD_OR_UPDATE_UNLISTED_STOCKS,
    GET_UNLISTED_STOCKS_BY_APPLICATION_ID,
    GET_APPLICANT_ASSESMENT_INFO_BY_APPLICATION_ID,
    GET_APPLICANT_ASSESMENT_INFO_BY_APPLICATION_ID_WITH_BANKER_ADJUSTMENT,
    GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID,
    DELETE_UNLISTED_STOCKS_BY_UNLISTED_STOCK_ID,
    ADD_OR_UPDATE_INVESTMENT,
    GET_INVESTMENT_BY_APPLICATION_ID,
    DELETE_INVESTMENT_BY_INVESTMENT_ID,
    ADD_OR_UPDATE_GENERAL_AND_LIMITED_PARTENERSHIP,
    GET_GENERAL_AND_LIMITED_PARTENERSHIP_BY_APPLICATION_ID,
    DELETE_GENERAL_AND_LIMITED_PARTENERSHIP_BY_INVESTMENT_ID,
    CONFIRM_EMAIL_OTP_FOR_USER_ACCOUNT,
    ADD_OR_UPDATE_NOTES_PAYABLE_BANK_SECURED,
    GET_NOTES_PAYABLE_BANK_SECURED_BY_APPLICATION_ID,
    DELETE_NOTES_PAYABLE_BANK_SECURED_BY_NOTES_ID,
    ADD_OR_UPDATENOTES_PAYABLE_BANK_UNSECURED,
    GET_NOTES_PAYABLE_BANK_UNSECURED_BY_APPLICATION_ID,
    DELETE_NOTES_PAYABLE_BANK_UNSECURED_BY_NOTES_ID,
    ADD_OR_UPDATE_NOTES_PAYABLE_OTHER,
    GET_NOTES_PAYABLE_OTHER_BY_APPLICATION_ID,
    DELETE_NOTES_PAYABLE_OTHER_BY_NOTES_ID,
    ADD_OR_UPDATE_ACCOUNTS_PAYABLE,
    GET_ACCOUNTS_PAYABLE_BY_APPLICATION_ID,
    DELETE_ACCOUNTS_PAYABLE_BY_ACCOUNT_ID,
    ADD_OR_UPDATE_CREDIT_CARD_BALANCE,
    GET_CREDIT_CARD_BALANCE_BY_APPLICATION_ID,
    DELETE_CREDIT_CARD_BALANCE_BY_CREDIT_ID,
    ADD_OR_UPDATE_MORTGAGE_DUE_WITHIN,
    GET_MORTGAGE_DUE_WITHIN_BY_APPLICATION_ID,
    DELETE_DOCUMENT_DATA_BY_APPLICATION_ID,
    DELETE_APPLICATION_BY_APPLICATION_ID,
    SUBMIT_APPLICATION_BY_APPLICATION_ID,
    DELETE_MORTGAGE_DUE_WITHIN_BY_ID,
    ADD_OR_UPDATE_MORTGAGE_DUE_BEYOND,
    GET_MORTGAGE_DUE_BEYOND_BY_APPLICATION_ID,
    DELETE_MORTGAGE_DUE_BEYOND_BY_ID,
    GET_ALL_QUESTIONS,
    ADD_OR_UPDATE_QUESTIONS,
    GET_QUESTIONS_BY_APPLICATION_ID,
    GET_SPONSER_DATA_BY_APPLICANT_EMAIL,
    GET_APPLICATION_STATUS_BY_APPLICATION_ID,
    GET_APPLICATION_STATUS_BY_APPLICATION_ID_AND_DOB,
    USER_LOGIN,
    FORGOT_USER_PASSWORD,
    FORGOT_PASSWORD_SEND_EMAIL_OTP,
    GET_BANK_ADMIN_LIST_BY_EMAIL,
    GET_APPLICANTS_BY_EMAIL_AND_BANK_ADMIN,
    GET_FIRM_ADMIN_DASHBOARD_BY_EMAIL_AND_BANK_ADMIN_ID,
    GET_FIRM_CREDIT_FACILITY_LIST_BY_EMAIL_AND_BANK_ADMIN_ID,
    GET_SPONSER_FACILITY_LIST_BY_FIRM_ID_FOR_FIRM_ADMIN,
    GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID_AND_SECTION,
    GET_APPLICANT_INFORMATION_BY_APP_ID,
    GET_APPLICANT_DASHBOARD_DATA_BY_EMAIL_AND_BANKER,
    GET_ASSET_CLASS_TYPES_SUMMARY_BY_APPLICATION_ID,
    ADD_ACCOUNT_LIVE_BALANCE_DATA,
    GET_APPLICANT_LIVE_BALANCE_LIST_BY_APPLICATION_ID,
    GET_APPLICANT_LIVE_BALANCE_BY_SPONSER_ID,
    GET_APPLICANT_LIVE_BALANCE_LIST_BY_SPONSER_ID_AND_LOAN_PROGRAME_TYPE,
    CREATE_PREPOPULATED_PDF_FOR_PATRIOT_ACT,
    ADD_APPLICANT_ADVANCE_REPAYMENT_BATCH_DATA,
    GET_APPLICANT_ADVANCE_REPAYMENT_BATCH_HISTORY
} from "../constants/constants";

let _NewapplicationService = {
    async userLogin(obj) {
        return await instance.post(USER_LOGIN, obj);
    },
    async verifyEmail(obj) {
        return await instance.post(SEND_VERIFY_EMAIL_OTP, obj);
    },
    async verifyOtp(obj) {
        return await instance.post(CONFIRM_EMAIL_OTP, obj);
    },
    async forgotPasswordSendEmailOTP(obj) {
        return await instance.post(FORGOT_PASSWORD_SEND_EMAIL_OTP, obj);
    },
    async forgotUserLoginPassword(reqObj) {
        return await instance.post(FORGOT_USER_PASSWORD, reqObj);
    },
    async updateUserPassword(reqObj) {
        return await instance.post(UPDATE_APPLICANT_DATA, reqObj);
    },
    async verifyOtpForUserAccount(obj) {
        return await instance.post(CONFIRM_EMAIL_OTP_FOR_USER_ACCOUNT, obj);
    },
    async getAllDropdownDataByName(dropdownDataByName, type = "") {
        return await instance.post(GET_ALL_DROPDOWN_DATA_BY_NAME, { parameter: dropdownDataByName, type: type });
    },
    async getApplicantInformationByApplicationId(applicationId) {
        return await instance.post(GET_APPLICANT_INFORMATION_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async createPrepopulatedPDFforPatriotAct(applicationId) {
        return await instance.post(CREATE_PREPOPULATED_PDF_FOR_PATRIOT_ACT, { applicationId: applicationId });
    },
    async addApplicantAdvanceRepaymentBatchData(obj) {
        return await instance.post(ADD_APPLICANT_ADVANCE_REPAYMENT_BATCH_DATA, obj);
    },
    async getApplicantAdvanceRepaymentBatchHistory(sponserId, batchType) {
        return await instance.post(GET_APPLICANT_ADVANCE_REPAYMENT_BATCH_HISTORY, { sponserId: sponserId, batchType: batchType });
    },
    async submitApplicantData(reqObj) {
        return await instance.post(UPDATE_APPLICANT_DATA, reqObj);
    },
    async AddOrUpdateIncomeSource(reqObj) {
        return await instance.post(ADD_OR_UPDATE_INCOME_SOURCE, reqObj);
    },
    async getIncomeSourceByApplicationID(applicationId) {
        return await instance.post(GET_INCOME_SOURCE_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async addOrUpdateExpenses(reqObj) {
        return await instance.post(ADD_OR_UPDATE_EXPENSES, reqObj);
    },
    async getExpensesByApplicationID(applicationId) {
        return await instance.post(GET_EXPENSES_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async addUpdateCashShortTermInvestments(reqObj) {
        return await instance.post(ADD_OR_UPDATE_CASH_SHORT_TERM_INVESTMENTS, reqObj);
    },
    async getCashShortTermInvestmentsByApplicationID(applicationId) {
        return await instance.post(GET_CASH_SHORT_TERM_INVESTMENTS_BY_APPLICATIONID, { applicationId: applicationId });
    },
    async deleteCashShortTermInvestmentsByCashID(Id) {
        return await instance.post(DELETE_CASH_SHORT_TERM_INVESTMENTS_BY_CASH_ID, { id: Id });
    },
    async addOrUpdateStockBondGovSecurity(reqObj) {
        return await instance.post(ADD_OR_UPDATE_STOCK_BOND_GOV_SECURITY, reqObj);
    },
    async getStockBondGovSecurityByApplicationID(applicationId) {
        return await instance.post(GET_STOCK_BOND_GOV_SECURITY_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteStockBondGovSecurityByStockID(Id) {
        return await instance.post(DELETE_STOCK_BOND_GOV_SECURITY_BY_STOCK_ID, { id: Id });
    },
    async getAccountNoteReceivableByApplicationID(applicationId) {
        return await instance.post(GET_ACCOUNT_NOTE_RECEIVABLE_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async AddOrUpdateAccountNoteReceivable(reqObj) {
        return await instance.post(ADD_O_RUPDATE_ACCOUNT_NOTE_RECEIVABLE, reqObj);
    },
    async deleteAccountNoteReceivableByAccountID(Id) {
        return await instance.post(DELETE_ACCOUNT_NOTE_RECEIVABLE_BY_ACCOUNT_ID, { id: Id });
    },
    async addOrUpdateCashValueLifeInsurance(reqObj) {
        return await instance.post(ADD_OR_UPDATE_CASH_VALUE_LIFE_INSURANCE, reqObj);
    },
    async deleteCashValueLifeInsuranceByCashValueID(Id) {
        return await instance.post(DELETE_CASH_VALUE_LIFE_INSURANCE_BY_CASHVALUE_ID, { id: Id });
    },
    async getCashValueLifeInsuranceByApplicationID(applicationId) {
        return await instance.post(GET_CASH_VALUE_LIFE_INSURANCE_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async updateApplicantFinancialData(reqObj) {
        return await instance.post(UPDATE_APPLICANT_FINANCIAL_DATA, reqObj);
    },
    async getFinancialStatementData(applicationId, screenName) {
        return await instance.post(GET_FINANCIAL_STATEMENT_DATA, { applicationId: applicationId, screenName: screenName });
    },
    async addOrUpdateOwnPersonalResidence(reqObj) {
        return await instance.post(ADD_OR_UPDATE_OWN_PERSONAL_RESIDENCE, reqObj);
    },
    async getOwnPersonalResidenceByApplicationID(applicationId) {
        return await instance.post(GET_OWN_PERSONAL_RESIDENCE_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteOwnPersonalResidenceByOwnID(Id) {
        return await instance.post(DELETE_OWN_PERSONAL_RESIDENCE_BY_OWN_ID, { id: Id });
    },
    async saveProofOfTrustData(reqObj) {
        return await instance.post(Submit_Applicant_Details_Api, reqObj, {
            headers: { "Content-Type": "application/json" }
        });
    },
    async saveUploadDocumentData(reqObj) {
        return await instance.post(Submit_Upload_Documents_Api, reqObj);
    },
    async getApplicantInformationByAppId(applicationId) {
        return await instance.post(GET_APPLICANT_INFORMATION_BY_APP_ID, { applicationId: applicationId });
    },
    async getApplicationListByEmail(emailId) {
        return await instance.post(GET_APPLICATION_LIST_BY_EMAIL, { email: emailId });
    },
    async UploadPhotoImage(formData, applicationId, uploadPhotoName) {
        formData.append("uploadPhotoName", uploadPhotoName);
        formData.append("applicationId", applicationId);
        return await instanceRoot.post(UPLOAD_PHOTO_IMAGE, formData);
    },
    async UploadPdfOrDocFile(formData, applicationId, uploadFieldsName) {
        formData.append("UploadFieldsName", uploadFieldsName);
        formData.append("applicationId", applicationId);
        return await instanceRoot.post(UPLOAD_PDF_OR_DOC_FILE, formData);
    },
    async UploadPdfOrDocFileRowId(formData, applicationId, uploadFieldsName, rowId) {
        formData.append("UploadFieldsName", uploadFieldsName);
        formData.append("applicationId", applicationId);
        formData.append("rowId", rowId);
        return await instanceRoot.post(UPLOAD_PDF_OR_DOC_FILE, formData);
    },
    async UploadSponserReportDocument(formData, uploadFieldsName, rowId, sponserId) {
        formData.append("UploadFieldsName", uploadFieldsName);
        formData.append("applicationId", 0);
        formData.append("rowId", rowId);
        formData.append("sponserId", sponserId);
        return await instanceRoot.post(UPLOAD_PDF_OR_DOC_FILE, formData);
    },

    async addOrUpdateVestedIntrestPension(reqObj) {
        return await instance.post(ADD_OR_UPDATE_VESTED_INTREST_PENSION, reqObj);
    },
    async getVestedIntrestPensionByApplicationID(applicationId) {
        return await instance.post(GET_VESTED_INTREST_PENSION_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteVestedIntrestPensionByOwnID(Id) {
        return await instance.post(DELETE_VESTED_INTREST_PENSION_BY_OWN_ID, { id: Id });
    },
    async addOrUpdateUnListedStocks(reqObj) {
        return await instance.post(ADD_OR_UPDATE_UNLISTED_STOCKS, reqObj);
    },
    async getUnListedStocksByApplicationID(applicationId) {
        return await instance.post(GET_UNLISTED_STOCKS_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async getApplicantAssesmentInfoByApplicationId(applicationId) {
        return await instance.post(GET_APPLICANT_ASSESMENT_INFO_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    // Banker-family roles' Assessment tab: same response shape as the method above, with Banker
    // Adjustment overlay applied server-side where present.
    async getApplicantAssesmentInfoByApplicationIdWithBankerAdjustment(applicationId) {
        return await instance.post(GET_APPLICANT_ASSESMENT_INFO_BY_APPLICATION_ID_WITH_BANKER_ADJUSTMENT, { applicationId: applicationId });
    },

    async getReviewCommentByApplicationId(applicationId) {
        return await instance.post(GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteUnListedStocksByunlistedStockID(Id) {
        return await instance.post(DELETE_UNLISTED_STOCKS_BY_UNLISTED_STOCK_ID, { id: Id });
    },
    async addOrUpdateInvestment(reqObj) {
        return await instance.post(ADD_OR_UPDATE_INVESTMENT, reqObj);
    },
    async getInvestmentByApplicationID(applicationId) {
        return await instance.post(GET_INVESTMENT_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteInvestmentByInvestmentID(Id) {
        return await instance.post(DELETE_INVESTMENT_BY_INVESTMENT_ID, { id: Id });
    },
    async addOrUpdateGeneralAndLimitedPartenership(reqObj) {
        return await instance.post(ADD_OR_UPDATE_GENERAL_AND_LIMITED_PARTENERSHIP, reqObj);
    },
    async getGeneralAndLimitedPartenershipByApplicationID(applicationId) {
        return await instance.post(GET_GENERAL_AND_LIMITED_PARTENERSHIP_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteGeneralAndLimitedPartenershipByInvestmentID(Id) {
        return await instance.post(DELETE_GENERAL_AND_LIMITED_PARTENERSHIP_BY_INVESTMENT_ID, { id: Id });
    },
    async addOrUpdateNotesPayableBankSecured(reqObj) {
        return await instance.post(ADD_OR_UPDATE_NOTES_PAYABLE_BANK_SECURED, reqObj);
    },
    async getNotesPayableBankSecuredByApplicationID(applicationId) {
        return await instance.post(GET_NOTES_PAYABLE_BANK_SECURED_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteNotesPayableBankSecuredByNotesID(Id) {
        return await instance.post(DELETE_NOTES_PAYABLE_BANK_SECURED_BY_NOTES_ID, { id: Id });
    },
    async addOrUpdateNotesPayableBankUnSecured(reqObj) {
        return await instance.post(ADD_OR_UPDATENOTES_PAYABLE_BANK_UNSECURED, reqObj);
    },
    async getNotesPayableBankUnSecuredByApplicationID(applicationId) {
        return await instance.post(GET_NOTES_PAYABLE_BANK_UNSECURED_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteNotesPayableBankUnSecuredByNotesID(Id) {
        return await instance.post(DELETE_NOTES_PAYABLE_BANK_UNSECURED_BY_NOTES_ID, { id: Id });
    },
    async addOrUpdateNotesPayableOther(reqObj) {
        return await instance.post(ADD_OR_UPDATE_NOTES_PAYABLE_OTHER, reqObj);
    },
    async getNotesPayableOtherByApplicationID(applicationId) {
        return await instance.post(GET_NOTES_PAYABLE_OTHER_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteNotesPayableOtherByNotesID(Id) {
        return await instance.post(DELETE_NOTES_PAYABLE_OTHER_BY_NOTES_ID, { id: Id });
    },
    async addOrUpdateAccountsPayable(reqObj) {
        return await instance.post(ADD_OR_UPDATE_ACCOUNTS_PAYABLE, reqObj);
    },
    async getAccountsPayableByApplicationID(applicationId) {
        return await instance.post(GET_ACCOUNTS_PAYABLE_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteAccountsPayableByAccountID(Id) {
        return await instance.post(DELETE_ACCOUNTS_PAYABLE_BY_ACCOUNT_ID, { id: Id });
    },
    async addOrUpdateCreditCardBalance(reqObj) {
        return await instance.post(ADD_OR_UPDATE_CREDIT_CARD_BALANCE, reqObj);
    },
    async getCreditCardBalanceByApplicationID(applicationId) {
        return await instance.post(GET_CREDIT_CARD_BALANCE_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteCreditCardBalanceByCreditID(Id) {
        return await instance.post(DELETE_CREDIT_CARD_BALANCE_BY_CREDIT_ID, { id: Id });
    },
    async addOrUpdateMortgageDueWithin(reqObj) {
        return await instance.post(ADD_OR_UPDATE_MORTGAGE_DUE_WITHIN, reqObj);
    },
    async getMortgageDueWithinByApplicationID(applicationId) {
        return await instance.post(GET_MORTGAGE_DUE_WITHIN_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteDocumentDataByApplicationId(applicationId, docName) {
        return await instance.post(DELETE_DOCUMENT_DATA_BY_APPLICATION_ID, { applicationId: applicationId, docName: docName });
    },
    async deleteApplicationByAppId(applicationId) {
        return await instance.post(DELETE_APPLICATION_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async submitApplicationByAppId(obj) {
        return await instance.post(SUBMIT_APPLICATION_BY_APPLICATION_ID, obj);
    },
    async deleteMortgageDueWithinByID(Id) {
        return await instance.post(DELETE_MORTGAGE_DUE_WITHIN_BY_ID, { id: Id });
    },
    async addOrUpdateMortgageDueBeyond(reqObj) {
        return await instance.post(ADD_OR_UPDATE_MORTGAGE_DUE_BEYOND, reqObj);
    },
    async getMortgageDueBeyondByApplicationID(applicationId) {
        return await instance.post(GET_MORTGAGE_DUE_BEYOND_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async deleteMortgageDueBeyondByID(Id) {
        return await instance.post(DELETE_MORTGAGE_DUE_BEYOND_BY_ID, { id: Id });
    },
    async getAllQuestions() {
        let url = GET_ALL_QUESTIONS;
        return await instance.get(url);
    },
    async addOrUpdateQuestions(reqObj) {
        return await instance.post(ADD_OR_UPDATE_QUESTIONS, reqObj);
    },
    async getQuestionsByApplicationID(applicationId) {
        return await instance.post(GET_QUESTIONS_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async getSponserDataByApplicantEmail(emailId, sponserId) {
        return await instance.post(GET_SPONSER_DATA_BY_APPLICANT_EMAIL, { email: emailId, sponserId: sponserId });
    },
    async getApplicationStatusByApplicationId(applicationId) {
        return await instance.post(GET_APPLICATION_STATUS_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async getApplicationStatusByApplicationIdDOB(applicationId, dob) {
        return await instance.post(GET_APPLICATION_STATUS_BY_APPLICATION_ID_AND_DOB, { applicationId: applicationId, applicantDOB: dob });
    },
    async getBankAdminListByEmail(emailId, IsFirmAdmin) {
        return await instance.post(GET_BANK_ADMIN_LIST_BY_EMAIL, { email: emailId, isFirmAdmin: IsFirmAdmin });
    },
    async getApplicantsByEmailAndBankAdmin(emailId, id) {
        return await instance.post(GET_APPLICANTS_BY_EMAIL_AND_BANK_ADMIN, { email: emailId, bankAdminId: id });
    },

    async getApplicantDashboardDataByEmailAndBanker(emailId, bankerId) {
        return await instance.post(GET_APPLICANT_DASHBOARD_DATA_BY_EMAIL_AND_BANKER, { email: emailId, bankerId: bankerId });
    },

    async getAssetClassTypesSummaryByApplicationId(applicationId) {
        return await instance.post(GET_ASSET_CLASS_TYPES_SUMMARY_BY_APPLICATION_ID, { applicationId: applicationId });
    },

    async getFirmAdminDashboardByEmailandBankAdminId(email, BankAdminId) {
        return await instance.post(GET_FIRM_ADMIN_DASHBOARD_BY_EMAIL_AND_BANK_ADMIN_ID, { email: email, bankAdminId: BankAdminId });
    },
    async getFirmCreditFacilityListByEmailAndBankAdminId(email, bankAdminId) {
        return await instance.post(GET_FIRM_CREDIT_FACILITY_LIST_BY_EMAIL_AND_BANK_ADMIN_ID, { email: email, bankAdminId: bankAdminId });
    },
    async getSponserFacilityListByFirmIdForFirmAdmin(firmId, email, bankAdminId) {
        return await instance.post(GET_SPONSER_FACILITY_LIST_BY_FIRM_ID_FOR_FIRM_ADMIN, { firmId: firmId, email: email, bankAdminId: bankAdminId });
    },
    async getApplicationReviewCommentByApplicationIdAndSection(applicationId, section) {
        return await instance.post(GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID_AND_SECTION, { applicationId: applicationId, section: section });
    },
    async addAccountLiveBalanceData(reqObj) {
        return await instance.post(ADD_ACCOUNT_LIVE_BALANCE_DATA, reqObj);
    },
    async getApplicantLiveBalanceListByApplicationId(applicationId) {
        return await instance.post(GET_APPLICANT_LIVE_BALANCE_LIST_BY_APPLICATION_ID, { applicationId: applicationId });
    },
    async getApplicantLiveBalanceBySponserId(sponserId) {
        return await instance.post(GET_APPLICANT_LIVE_BALANCE_BY_SPONSER_ID, { sponserId: sponserId });
    },
    async getApplicantLiveBalanceListBySponserIdAndLoanProgrameType(sponserId, loanProgrameTypeId) {
        return await instance.post(GET_APPLICANT_LIVE_BALANCE_LIST_BY_SPONSER_ID_AND_LOAN_PROGRAME_TYPE, { sponserId: sponserId, loanProgrameTypeId: loanProgrameTypeId });
    },
};

export default _NewapplicationService;